import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { resolveSpacing, v8ResponsiveToPanda } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const resolveAlignment = (value) => {
  const resolved = v8ResponsiveToPanda(value);
  const mapped = Object.fromEntries(Object.entries(resolved).map(([k, v]) => [k, v === "none" || v === "None" ? "auto" : v]));
  return Object.keys(mapped).length > 0 ? mapped : void 0;
};
const isNoGap = (value) => value === null || value === "" || value === "None" || value === "none";
const TABLET_EXCEEDS_MAX = ["xl", "layout.looser"];
const MOBILE_EXCEEDS_MAX = ["lg", "looser", "xl", "layout.looser"];
const BlockGridLayout = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    id,
    ...restAttrs
  } = attrs ?? {};
  const attributes = {
    gridTemplateColumns: {
      default: "repeat(12, minmax(0, 1fr))"
    },
    gap: {
      default: "md",
      lg_lte: "md",
      sm_lte: "md"
    },
    justifyContent: {
      default: "center"
    },
    alignItems: {
      default: "center"
    },
    // When child of things that center the content, we still want
    // Grid to be stretched. For example, as child of Carousel.
    alignSelf: {
      default: "stretch"
    },
    ...restAttrs
  };
  const gap = Object.fromEntries(Object.entries(attributes.gap ?? {}).map(([breakpoint, value]) => [breakpoint, isNoGap(value) ? "none" : value]));
  if (!gap.lg_lte || TABLET_EXCEEDS_MAX.includes(gap.lg_lte)) {
    gap.lg_lte = "md";
  }
  if (!gap.sm_lte || MOBILE_EXCEEDS_MAX.includes(gap.sm_lte)) {
    gap.sm_lte = "md";
  }
  const className = css({
    display: "grid",
    gridTemplateColumns: v8ResponsiveToPanda(attributes.gridTemplateColumns),
    gap: resolveSpacing(gap),
    justifyContent: resolveAlignment(attributes.justifyContent),
    alignItems: resolveAlignment(attributes.alignItems),
    alignSelf: resolveAlignment(attributes.alignSelf)
  });
  return /* @__PURE__ */ jsx(Box, { id, className, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
export {
  BlockGridLayout as default
};
